import { Component, Input } from '@angular/core';
import { Service } from './vdc-card.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { storageConverterRender, policyFormatter, retentionFormatter, tooltipFormatter, replicationTooltipFormatter } from '../../dataprotection-common/common-renderers';
import { AuthService } from '../../../../auth/auth.service';
import { JobConstants } from '../../../../../common/utils/job-constants';

@Component({
  selector: 'vdc-card',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./vdc-card.scss')],
  template: require('./vdc-card.html')
})

export class VdcCard {
  @Input('selectedVdcId') selectedVdcId;

  private subscribeHandler;
  private isDpsAddVdcPolicyPopupVisible: boolean = false;
  private isDpsEditVdcPolicyPopupVisible: boolean = false;
  private isDpsRemoveVdcPolicyPopupVisible: boolean = false;
  private isDpsVappsPopupVisible: boolean = false;
  private isDpsDeletedVappsPopupVisible: boolean = false;
  private isDpsActivityLogPopupVisible: boolean = false;
  private isConfigureEmailPopupVisible: boolean = false;
  private isSetReplicationSitePopupVisible: boolean = false;
  private isReplicationConfigurePolicyPopupVisible: boolean = false;
  private isReplicationEditPolicyPopupVisible: boolean = false;
  private isReplicationRemovePolicyPopupVisible: boolean = false;
  private dpsVappsPopupHeader: string;
  private dpsDeletedVappsPopupHeader: string;
  private dpsActivityLogPopupHeader: string;
  private dpsActivityLogPopupMode: string = DataProtectionVariables.MODES['VDC'];
  private dpsAddVdcPolicyPopupHeader: string;
  private dpsAddVdcPolicyPopupMode: string = DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VDC'];
  private dpsEditVdcPolicyPopupHeader: string;
  private dpsEditVdcPolicyPopupMode: string = DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VDC'];
  private dpsRemoveVdcPolicyPopupHeader: string;
  private dpsRemoveVdcPolicyPopupMode: string = DataProtectionVariables.MODES['VDC'];
  private configureEmailPopupHeader: string;
  private setReplicationSitePopupHeader:string;
  private replicationConfigurePolicyPopupHeader:string;
  private replicationEditPolicyPopupHeader:string;
  private replicationRemovePolicyPopupHeader:string;
  private storageConsumed: string = '';
  private policyText: string = '';
  private retentionText: string = '';
  private policyTooltip: string = ' - ';
  private jsonData: any;
  private loaded: boolean = false;
  private isScheduleEnabled: boolean = false;
  private replicationPolicyText: string = '';
  private replicationPolicyTooltip: string = ' - ';
  private isReplicationScheduleEnabled: boolean = false;
  private replicationSite: string = '';
  private isDpsHealthy: boolean = false;

  private activityLogService = JobConstants.SERVICES['VcdDpsJob'];
  private activityLogFilter;

  constructor(public service: Service, private translateService: TranslateService, public authService: AuthService) {
      this.authService.getDpsHealthChangeEvent().subscribe(data => {
        this.isDpsHealthy = ( data && data.isHealthy ) ? true : false;
      });
      translateService.use(GlobalVariables.LOCALE);
  }


  //Life Cycle Hooks
  ngOnInit() {
    this.isDpsHealthy = (this.authService.DPS_HEALTH && this.authService.DPS_HEALTH.isHealthy) ? true : false;
    if(this.selectedVdcId) {
      this.getVdcDetails();
    }
  }

  ngOnChanges(changes) {
    if(this.selectedVdcId) {
      this.getVdcDetails();
    }
    this.activityLogFilter = 'entityId=' + this.selectedVdcId;
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
  }


  onDPSOpenVapps = ($event) => {
    this.isDpsVappsPopupVisible = true;
    this.dpsVappsPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.vapps') + this.appendVDCName();
  }
  onDPSOpenDeletedVapps = ($event) => {
    this.isDpsDeletedVappsPopupVisible = true;
    this.dpsDeletedVappsPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.deletedVapps') + this.appendVDCName();
  }
  onDPSOpenActivityLog = ($event) => {
    this.isDpsActivityLogPopupVisible = true;
    this.dpsActivityLogPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.activityLog') + this.appendVDCName();
  }

  onDPSEditPolicyVDC = ($event) => {
    if(this.isScheduleAvailable()) {
      this.isDpsEditVdcPolicyPopupVisible = true;
      this.dpsEditVdcPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.editPolicyVDC') + this.appendVDCName();
    }
  }

  onDPSAddPolicyVDC = ($event) => {
    if(!this.isScheduleAvailable()) {
      this.isDpsAddVdcPolicyPopupVisible = true;
      this.dpsAddVdcPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.addPolicyVDC') + this.appendVDCName();
    }
  }

  onDPSremovePolicyVDC = ($event) => {
    if(this.isScheduleAvailable()) {
      this.isDpsRemoveVdcPolicyPopupVisible = true;
      this.dpsRemoveVdcPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.removePolicyVDC') + this.appendVDCName();
    }
  }

  onDPSConfigureEmail = ($event) => {
    this.isConfigureEmailPopupVisible = true;
    this.configureEmailPopupHeader = this.translateService.instant('dpsModule.configureEmail.popupHeaderVDC') + this.appendVDCName();
  }

  appendVDCName() {
    let returnValue:string = "";
    if(this.jsonData && this.jsonData.name) {
        returnValue = " - " + this.jsonData.name;
    }
    return returnValue;
  }

  onDPSAddPolicyClose(event) {
    if(event && event.value) {
      this.isDpsAddVdcPolicyPopupVisible = false;
      this.getVdcDetails();
    }
  }

  onDPSEditPolicyClose(event) {
    if(event && event.value) {
      this.isDpsEditVdcPolicyPopupVisible = false;
      this.getVdcDetails();
    }
  }

  onDPSRemovePolicyClose(event) {
    if(event && event.value) {
      this.isDpsRemoveVdcPolicyPopupVisible = false;
      this.getVdcDetails();
    }
  }

  onConfigureEmailClose(event) {
    if(event && event.value) {
      this.isConfigureEmailPopupVisible = false;
    }
  }


  onReplicationSetSite = ($event) => {
      this.isSetReplicationSitePopupVisible = true;
      this.setReplicationSitePopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.setReplicationSite') + this.appendVDCName();
  }

  onReplicationSetSiteClose(event) {
    if(event && event.value) {
      this.isSetReplicationSitePopupVisible = false;
      this.getVdcDetails();
    }
  }

  onReplicationConfigurePolicy = ($event) => {
      if(this.isReplicationScheduleAvailable('CONFIGURE')) {
        this.isReplicationConfigurePolicyPopupVisible = true;
        this.replicationConfigurePolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.configureReplicationPolicy') + this.appendVDCName();
      }
  }

  onReplicationConfigurePolicyClose(event) {
    if(event && event.value) {
      this.isReplicationConfigurePolicyPopupVisible = false;

      this.getVdcDetails();
    }
  }

  onReplicationEditPolicy = ($event) => {
      if(this.isReplicationScheduleAvailable(null)) {
        this.isReplicationEditPolicyPopupVisible = true;
        this.replicationEditPolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.editReplicationPolicy') + this.appendVDCName();
      }
  }

  onReplicationEditPolicyClose(event) {
    if(event && event.value) {
      this.isReplicationEditPolicyPopupVisible = false;

      this.getVdcDetails();
    }
  }

  onReplicationRemovePolicy = ($event) => {
      if(this.isReplicationScheduleAvailable(null)) {
        this.isReplicationRemovePolicyPopupVisible = true;
        this.replicationRemovePolicyPopupHeader = this.translateService.instant('dpsModule.cards.vdc.dialogTitles.removeReplicationPolicy') + this.appendVDCName();
      }
  }

  onReplicationRemovePolicyClose(event) {
    if(event && event.value) {
      this.isReplicationRemovePolicyPopupVisible = false;
      this.getVdcDetails();
    }
  }

  getVdcDetails() {
    if(this.selectedVdcId) {
      this.subscribeHandler = this.service.getVdcs(this.selectedVdcId)
        .subscribe(
          res => {
            this.jsonData = res;
            if(this.jsonData) {
              this.policyText = policyFormatter(this.jsonData);
              this.retentionText = retentionFormatter(this.jsonData).replace(/ \| /gi, "");
              this.policyTooltip = tooltipFormatter(this.jsonData);
              this.replicationPolicyText = (this.jsonData && this.jsonData.replicationPolicy) ? policyFormatter(this.jsonData.replicationPolicy) : "-";
              this.replicationPolicyTooltip = (this.jsonData && this.jsonData.replicationPolicy) ? replicationTooltipFormatter(this.jsonData.replicationPolicy) : "-";
              this.replicationSite = (this.jsonData && this.jsonData.replicationSite) ? this.jsonData.replicationSite : "-";
            }
            if(this.jsonData && this.jsonData.schedule && this.jsonData.schedule.hasOwnProperty('scheduleType'))
              this.isScheduleEnabled = true;
            else
              this.isScheduleEnabled = false;
            if(this.jsonData && this.jsonData.statistics && this.jsonData.statistics.hasOwnProperty('storageConsumed'))
              this.storageConsumed = storageConverterRender(this.jsonData.statistics.storageConsumed, 'MB');

            if(this.jsonData && this.jsonData.replicationPolicy && this.jsonData.replicationPolicy.schedule && this.jsonData.replicationPolicy.schedule.hasOwnProperty('scheduleType')) {
              this.isReplicationScheduleEnabled = true;
            }else{
              this.isReplicationScheduleEnabled = false;
            }
            this.loaded = true;
          },
          error => this.logError(error, 'get vdc card details'),
          () => this.logOperationCompleted('get vdc card details')
        );
    }
    else {
      this.logError('Incorrect VDC information while fetching vdc card details');
      this.jsonData = {};
      this.policyText = "";
      this.retentionText = "";
      this.policyTooltip = " - ";
      this.isScheduleEnabled = false;
      this.isReplicationScheduleEnabled = false;
      this.storageConsumed = storageConverterRender(0, 'MB');
      this.replicationPolicyText = "";
      this.replicationPolicyTooltip = "-";
      this.replicationSite = "-";
    }
  }

  isScheduleAvailable() {
    let retrurnValue:boolean = false;
    if( this.jsonData && this.jsonData.hasOwnProperty('schedule') && this.jsonData.schedule ) {
      retrurnValue = true;
    }
    return retrurnValue;
  }

  isReplicationScheduleAvailable(configPolicy) {
    let returnValue:boolean = false;
    if (configPolicy && configPolicy == "CONFIGURE") {
      if( !this.jsonData.replicationSite
        ||  this.jsonData.replicationPolicy ) {
        returnValue = true;
      }
    }else{
      if( this.jsonData && this.jsonData.hasOwnProperty('replicationSite')
        && this.jsonData.hasOwnProperty('replicationPolicy')
        &&  this.jsonData.replicationSite
        &&  this.jsonData.replicationPolicy ) {
        returnValue = true;
      }
    }
    return returnValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vdc-card/vdc-card.component.ts